import React, { useEffect } from "react";
import { Alert, message, Modal } from "antd";
import useApi from "../../hooks/useApi";
import { API_METHODS } from "../../constants";

function DeleteModal(props) {
  const [deleteResponse, deleteRequest] = useApi("/", null, API_METHODS.DELETE);

  const { visible, close, recordType, record, refresh } = props;
  const handleOk = () => {
    switch (recordType) {
      case "ReleaseOrder-0":
        return deleteRequest(
          null,
          API_METHODS.DELETE,
          `/releaseOrder/${record.id}?isClassified=0`
        );
      case "ReleaseOrder-1":
        return deleteRequest(
          null,
          API_METHODS.DELETE,
          `/releaseOrder/${record.id}?isClassified=1`
        );
      case "PartyBill-0":
        return deleteRequest(
          null,
          API_METHODS.DELETE,
          `/partyBill/${record.id}?isClassified=0`
        );
      case "PartyBill-1":
        return deleteRequest(
          null,
          API_METHODS.DELETE,
          `/partyBill/${record.id}?isClassified=1`
        );
      case "Receipt":
        return deleteRequest(null, API_METHODS.DELETE, `/receipt/${record.id}`);
    }
  };

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      message.success("Record deleted successfully.");
      close();
      refresh();
    } else if (deleteResponse.error && !deleteResponse.isLoading) {
      message.error("Unable to delete Record. Please try again.");
    }
  }, [deleteResponse]);

  return (
    <Modal
      title="Delete"
      open={visible}
      width={500}
      onCancel={close}
      maskClosable={false}
      onOk={handleOk}
      okText="Yes"
      cancelText={"No"}
    >
      <Alert
        message=" Are you sure, you want to delete this record?"
        type="error"
      />
    </Modal>
  );
}

export default DeleteModal;
